export const getFeesIsFetching = state => state.feesReducer.isFetching;
export const getFeesError = state => state.feesReducer.error;

export const getAllFees = state => state.feesReducer.fees;
export const getSpecificFee = (state, action) => state.feesReducer.fees[action];
